import { ADD_UDATA } from "./actionsTyprs";

export const addUdata = uData => {
  return {
    type: ADD_UDATA,
    uData: uData,
  };
};
